"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Dimensions_1 = require("../../utils/Dimensions");
const generateStyles_1 = require("../../utils/generateStyles");
const FALLBACK_VALUES = {
    color: "inherit",
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderRadius: Dimensions_1.Dimensions.d8,
};
// prettier-ignore
exports.StyledBox = styled_components_1.default.div `
    padding: ${Dimensions_1.Dimensions.d16};
    color: ${({ color }) => color || FALLBACK_VALUES.color};
    background-color: ${({ backgroundColor }) => backgroundColor || FALLBACK_VALUES.backgroundColor};
    border-radius: ${({ borderRadius }) => borderRadius || FALLBACK_VALUES.borderRadius};
    box-shadow: inset 0 0 0 1px ${({ borderColor }) => borderColor || FALLBACK_VALUES.borderColor};
    display: ${({ isBlock }) => isBlock ? "block" : "inline-block"};

    ${({ px }) => px && (0, generateStyles_1.getStylesWithBreakpoints)(px, (value) => `padding-left: ${value}; padding-right: ${value};`)}
    ${({ py }) => py && (0, generateStyles_1.getStylesWithBreakpoints)(py, (value) => `padding-top: ${value}; padding-bottom: ${value};`)}
    ${({ pt }) => pt && (0, generateStyles_1.getStylesWithBreakpoints)(pt, (value) => `padding-top: ${value};`)}
    ${({ pr }) => pr && (0, generateStyles_1.getStylesWithBreakpoints)(pr, (value) => `padding-right: ${value};`)}
    ${({ pb }) => pb && (0, generateStyles_1.getStylesWithBreakpoints)(pb, (value) => `padding-bottom: ${value};`)}
    ${({ pl }) => pl && (0, generateStyles_1.getStylesWithBreakpoints)(pl, (value) => `padding-left: ${value};`)}
`;
//# sourceMappingURL=Box.styles.js.map